import envConfig from '@hulu/env-config';

/**
 * When true, feature flags are fetched via the GQL featureFlags query (server-side LD + relay).
 * When false, the browser LaunchDarkly SDK is used (legacy path).
 *
 * Set via REACT_APP_FEATURE_FLAGS_VIA_GQL at pod startup (serve-injected); flip + restart to roll back.
 */
export const isFeatureFlagsViaGql = (): boolean => envConfig.REACT_APP_FEATURE_FLAGS_VIA_GQL === 'true';
